import { Button, Col, InputNumber, Popover, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

const SetQuantity = ({ handleSetSeriesQuantity }) => {
  const [quantity, setQuantity] = useState(1);
  const { formatMessage } = useIntl();

  const handleChangeQuantity = (value) => setQuantity(value);

  useEffect(() => {
    handleSetSeriesQuantity(quantity);
  }, [quantity]);

  return (
    <Row>
      <Col span={24}>
        <Typography.Title className={"text-center"} level={5}>
          How many Series do you want to create with this configuration?
        </Typography.Title>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <InputNumber value={quantity} onChange={handleChangeQuantity} min={1} className={"mb-2"} />
          <Popover
            trigger="click"
            content={formatMessage({
              id: "form.help.series.create.many",
              defaultMessage: "Create more than one series at a time",
            })}
          >
            <Button type="text" outline color="danger" size="sm">
              <i className="fas fa-circle-question" />
            </Button>
          </Popover>
        </div>
      </Col>
    </Row>
  );
};

export default SetQuantity;
